module.exports = __webpack_public_path__ + "703d8284fbd1bd925e657d7a64ef084a.glb";